import React, { Component } from 'react'
import { DetailLoader } from 'components/loaders'
import { Form } from 'components/layout'

class Translator extends Component {
  render() {
    return (
      <div className="base-margin container">
        Loader test:

        <DetailLoader />

        <Form loading contentLoader={<DetailLoader />}>
          Form loader
        </Form>
        <Form loading>
          Form loade2
        </Form>
      </div>
    )
  }
}

export default Translator
